<script>
export default {
  name: "DetailSessionCard",
  props: ["session", "active", "clickCallback"],

  methods: {
    getStatus(session) {
      var status = true;
      if (session && session.seats_available && session.seats_available <= 1) {
        status = false;
      }
      return status;
    },

    getStatusString(session) {
      var status = "";
      if (session && session.seats_available && session.seats_available <= 1) {
        status = "Sold Out";
      } else if (session && session.seats_available && session.seats_available <= 10) {
        status = "Limited Seats Available";
      }
      return status;
    },

    getExperienceIcon() {
      if (this.session && this.session.experiences) {
        const uri = "/static/experiences/";
        const experienceName = this.session.experiences[0].name;

        const img = experienceName.split(" OR ")[0].replaceAll(" ", "");

        return uri + img + ".jpg";
      } else {
        return '';
      }
    },

    getExperienceAlt() {
      if (this.session && this.session.experiences) {
        return this.session.experiences[0].name.replaceAll(" ", "");
      } else {
        return '';
      }
    },
  },
};
</script>

<template v-if="session && session.show_time">
    <div
      class="detail-movie__session-select"
      :class="{ active: active, 'btn-mask': true, disabled: !getStatus(session) }"
      @click="clickCallback(session)"
    > 
    <div class="detail-movie__session-select-inner">
      <div class="detail-movie__session-select-time">
        {{ session && session.show_time && session.show_time.additional.no_zero_hour_24 ? session.show_time.additional.no_zero_hour_24 : '' }}:{{
          session && session.show_time && session.show_time.additional.minute ? session.show_time.additional.minute : ''
        }}
      </div>
      <figure class="detail-movie__session-select-icon">
        <img :src="getExperienceIcon()" :alt="getExperienceAlt()" />
      </figure>
    </div>
    <template v-if="getStatusString(session)">
      <div
        class="detail-movie__session-select-status"
        :class="[getStatusString(session) == 'Sold Out' ? 'state--full' : '']"
      >
        {{ getStatusString(session) }}
      </div>
    </template>
  </div>
</template>

<style lang="scss">
.detail-movie__session-select {
  display: block;
  align-items: center;
  text-align: center;
  user-select: none;
  pointer-events: all;
  cursor: pointer;
  margin-bottom: 16px;
  transition: transform 0.1s linear;

  &:hover {
    transform: scale(1.05);
  }
}

.detail-movie__session-select-inner {
  background-color: #0b0d0f;
  color: #fff;
  padding: 10px 60px 10px 10px;
  min-width: 182px;
  font-family: Montserrat, sans-serif;
  line-height: 1;
  font-weight: 500;
  border-radius: 2px;
  position: relative;
  display: block;
}

.detail-movie__session-select-time {
  width: 100%;
  margin-bottom: 0;
  pointer-events: none;
  font-size: 32px;
  line-height: 40px;
}

.detail-movie__session-select-icon {
  pointer-events: none;
  position: absolute;
  right: 10px;
  top: 10px;
  bottom: 10px;
  margin: 0;
}

.detail-movie__session-select-status {
  pointer-events: none;
  font-size: 14px;
  padding: 3px 0;
  display: block;
  background: #007cbd;
  color: #fff;

  &.state--full {
    background: #ed4337;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// detailSessionCard.vue?920e8082